module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Печать PDF документа":"Print PDF document","Скачать PDF документ":"Download PDF document","Распечатать":"Print","Скачать PDF":"Download PDF"}}')
  delete Component.options._Ctor
}
